export const COMPANY_TYPES = [
	{ id: "private", title: "Private" },
	{ id: "public", title: "Public" },
	{ id: "self-employed", title: "Self-Employed" },
	{ id: "self-owned", title: "Self-Owned" },
	{ id: "partnership", title: "Partnership" },
	{ id: "nonprofit", title: "Nonprofit" },
	{ id: "educational", title: "Educational" },
	{ id: "government", title: "Government" },
];
